var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkTeamChallenges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Medal-Badge-Star--Streamline-Flex.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Medal Badge Star Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medal-badge-star--medal-badge-star-competition-winner-achievement"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.99805 9.5c2.88 0 4.49995 -1.62 4.49995 -4.5S9.87805 0.5 6.99805 0.5s-4.5 1.62 -4.5 4.5 1.62 4.5 4.5 4.5Z",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#e5eaf9",
    strokeLinejoin: "round",
    d: "M7.95489 3.68824c-0.08156 -0.32975 -0.19231 -0.62884 -0.33943 -0.90732 -0.26662 -0.50468 -0.96324 -0.50475 -1.23033 -0.00032 -0.1475 0.27857 -0.25859 0.57776 -0.34018 0.90764 -0.32447 -0.01156 -0.63347 0.00619 -0.9354 0.05682 -0.57273 0.09604 -0.80618 0.76477 -0.39943 1.17926 0.21473 0.21882 0.46008 0.40981 0.74427 0.5815 -0.10655 0.29075 -0.18058 0.57763 -0.22482 0.86768 -0.08972 0.58823 0.49077 1.02781 1.02103 0.75784 0.26122 -0.133 0.50803 -0.29868 0.74873 -0.5022 0.24088 0.20367 0.48811 0.36944 0.7498 0.50249 0.53041 0.26967 1.11086 -0.1699 1.02114 -0.75813 -0.04424 -0.29005 -0.11827 -0.57693 -0.22482 -0.86768 0.2842 -0.17169 0.52954 -0.36268 0.74428 -0.5815 0.40675 -0.41449 0.1733 -1.08322 -0.39944 -1.17926 -0.30192 -0.05063 -0.61093 -0.06838 -0.9354 -0.05682Z",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.0651 8.56738c-0.75106 0.61121 -1.78402 0.93273 -3.06705 0.93273 -1.281 0 -2.31272 -0.3205 -3.06349 -0.92982C3.86049 9.22162 3.75 10.3289 3.75 11.1388c0 0.4475 0.03373 0.9857 0.07641 1.4877 0.06325 0.7439 0.90255 1.1205 1.51773 0.6976L7 12.1857l1.65586 1.1384c0.61518 0.4229 1.45444 0.0463 1.51774 -0.6976 0.0427 -0.502 0.0764 -1.0402 0.0764 -1.4877 0 -0.8111 -0.1108 -1.92048 -0.1849 -2.57142Z",
    strokeWidth: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkTeamChallenges);
export default __webpack_public_path__ + "static/media/DarkTeamChallenges.8ace873ba8971b38a37b7f968dd3f3ec.svg";
export { ForwardRef as ReactComponent };